
import { useCallback, useRef, useState } from "react";
import { readJSON, writeJSON } from "../lib/safeStorage";

const KEY = "db_last_visit_ids_v1";
const CAP = 500;

// Tracks which listing ids were seen on prior visits so genuinely new listings
// can be highlighted once. The baseline is captured at mount (immutable state)
// and stays fixed for the session; seen ids accumulate and persist for the
// NEXT visit. The accumulator ref is only touched inside callbacks (never
// during render) to satisfy the React Compiler.
export function useLastVisit() {
  const [baseline] = useState<Set<number>>(
    () => new Set(readJSON<number[]>(KEY, []))
  );
  const seenRef = useRef<Set<number> | null>(null);

  const hasBaseline = baseline.size > 0;

  const isNew = useCallback(
    (id: number) => hasBaseline && !baseline.has(id),
    [baseline, hasBaseline]
  );

  const markSeen = useCallback(
    (ids: number[]) => {
      if (!seenRef.current) seenRef.current = new Set(baseline);
      const seen = seenRef.current;
      ids.forEach((id) => seen.add(id));
      let arr = [...seen];
      if (arr.length > CAP) arr = arr.slice(arr.length - CAP);
      writeJSON(KEY, arr);
    },
    [baseline]
  );

  return { isNew, markSeen, hasBaseline };
}
